// src/components/DynamicReportInputs/PeriodField.js
import React, { Fragment } from "react";
import { DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import InputAdornment from "@material-ui/core/InputAdornment";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import esLocale from "date-fns/locale/es";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ClearIcon from "@material-ui/icons/Clear";

export default function DateField(props) {
  return (
    <>
      <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
        <Fragment>
          <DatePicker
            label={props.label} // Agregado para que se vea el título del campo
            helperText={props.helperText}
            minDate={props.minDate}
            maxDate={props.maxDate}
            views={props.views}
            disabled={props.disabled}
            name={props.name}
            format={props.format}
            value={props.value}
            onChange={props.onChange}
            inputVariant="outlined"
            autoOk={true}
            className={props.fieldClassName}
            error={props.error}
            placeholder={props.placeholder}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {/* Botón limpiar (solo si clearable y hay valor) */}
                  {props.clearable && props.value ? (
                    <Tooltip title={props.clearTooltip || "Quitar selección"}>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          // devolvemos null; el padre decide qué hacer
                          props.onChange && props.onChange(null);
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  <CalendarTodayIcon />
                </InputAdornment>
              ),
            }}
          />
        </Fragment>
      </MuiPickersUtilsProvider>
    </>
  );
}